import { Component, Input, OnInit } from '@angular/core';

import * as _ from 'lodash';

@Component({
    selector: 'task-series-arrows',
    templateUrl: './taskSeriesArrows.component.html',
    imports: [],
})
export class TaskSeriesArrowsComponent implements OnInit {
    @Input() manyToOne: boolean;
    @Input() chevronWidth: number;
    @Input() padding: number;
    @Input() manyLength: number;

    startingPos: number;
    lineWidth: number;
    extraSeries: number[];

    ngOnInit(): void {
        this.startingPos = (this.chevronWidth + this.padding * 2) / 2;
        this.lineWidth = this.chevronWidth + this.padding * 3;
        this.extraSeries = _.range(this.manyLength - 1);
    }
}
